var sku_values_l = ''; //Valor de todas las combinaciones colocadas en el ojo izquierdo
var sku_values_r = ''; //Valor de todas las combinaciones colocadas en el ojo derecho
var var_l_sph = 'null'; //Este es el valor del SPH en el ojo izquierdo
var var_r_sph = 'null'; //Este es el valor del SPH en el ojo derecho
var var_l_cil = 'null'; //Este es el valor del CIL en el ojo izquierdo
var var_r_cil = 'null'; //Este es el valor del CIL en el ojo derecho
var var_l_eje = 'null'; //Este es el valor del EJE en el ojo izquierdo
var var_r_eje = 'null'; //Este es el valor del EJE en el ojo derecho
var var_l_col = ''; //Este es el valor del COL en el ojo izquierdo
var var_r_col = ''; //Este es el valor del COL en el ojo derecho
var l_times = 0;
var r_times = 0;

$('#left-poder-sph').click(function() {
  var_l_sph = $('#4358086557754_option_2').val();
  var var_l_sph_validator = var_l_sph+'_validator';
  
  if(var_l_sph_validator == 'null_validator'){  
    //Do nothing
  }else{
    if(var_l_cil == 'null' || var_l_eje == 'null'){
      //Do nothing
    }else{
      unify_values_l();
      fetch_sku_l();
    }
  }
});

$('#left-cilindro').click(function() {
  var_l_cil = $('#4358086557754_option_3').val();
  var var_l_cil_validator = var_l_sph+'_validator';
  
  if(var_l_cil_validator == 'null_validator'){
    //Do nothing  
  }else{
    if(var_l_sph == 'null' || var_l_eje == 'null'){
      //Do nothing
    }else{
      unify_values_l();
      fetch_sku_l();
    }
  }
});

$('#left-eje').click(function() {
  var_l_eje = $('#4358086557754_option_4').val();
  var var_l_eje_validator = var_l_sph+'_validator';
  
  if(var_l_eje_validator == 'null_validator'){  
    //Do nothing
  }else{
    if(var_l_sph == 'null' || var_l_cil == 'null'){
      //Do nothing
    }else{
      unify_values_l();
      fetch_sku_l();
    }
  }
});

$('#right-poder-sph').click(function() {
  var_r_sph = $('#4358086557754_option_6').val();
  var var_r_sph_validator = var_r_sph+'_validator';
  
  if(var_r_sph_validator == 'null_validator'){  
    //Do nothing
  }else{
    if(var_r_cil == 'null' || var_r_eje == 'null'){
      //Do nothing
    }else{
      unify_values_r();
      fetch_sku_r();
    }
  }
});

$('#right-cilindro').click(function() {
  var_r_cil = $('#4358086557754_option_7').val();
  var var_r_cil_validator = var_r_sph+'_validator';
  
  if(var_r_cil_validator == 'null_validator'){  
    //Do nothing
  }else{
    if(var_r_sph == 'null' || var_r_eje == 'null'){
      //Do nothing
    }else{
      unify_values_r();
      fetch_sku_r();
    }
  }
});

$('#right-eje').click(function() {
  var_r_eje = $('#4358086557754_option_8').val();
  var var_r_eje_validator = var_r_sph+'_validator';
  
  if(var_r_eje_validator == 'null_validator'){ 
    //Do nothing 
  }else{
    if(var_r_cil == 'null' || var_r_sph == 'null'){
      //Do nothing
    }else{
      unify_values_r();
      fetch_sku_r();
    }
  }
});


function unify_values_l(){
  if(var_l_sph != null && var_l_sph != 'null' && var_l_sph != '' && var_l_cil != null && var_l_cil != 'null' && var_l_cil != '' && var_l_eje != null && var_l_eje != 'null' && var_l_eje != '' ){
    sku_values_l = var_l_sph + '_' + var_l_cil +'_'+ var_l_eje; console.log(sku_values_l);
  }
}

function unify_values_r(){
  if(var_r_sph != null && var_r_sph != 'null' && var_r_sph != '' && var_r_cil != null && var_r_cil != 'null' && var_r_cil != '' && var_r_eje != null && var_r_eje != 'null' && var_r_eje != ''){
    sku_values_r = var_r_sph + '_' + var_r_cil +'_'+ var_r_eje; console.log(sku_values_r);
  }
}

function check_times(){
  // 1 = inmediata (actualmente no se usa), 2 = 7 días, 3 = 55 días, 4 = sin stock, 5 = sin stock en descontinuación
  setTimeout(function(){
    $('.shipping_date_cls, .shipping_date_change').remove();
    if (l_times == 1){ $('.lc-sistock-container').show(); $('.shipping_date_l').remove(); $('<p class="shipping_date_l" style="margin: 0 0 20px 0; font-weight: bold;"><span style="color:#fb4e0c;">TIEMPO DE ENTREGA:</span> Recibirás tu pedido en 7 días hábiles.</p>').insertBefore('.qty-label-l'); $('#left-entrega-estimada input').val('6');} 
    if (l_times == 2){ $('.lc-sistock-container').show(); $('.shipping_date_l').remove(); $('<p class="shipping_date_l" style="margin: 0 0 20px 0; font-weight: bold;"><span style="color:#fb4e0c;">TIEMPO DE ENTREGA:</span> Recibirás tu pedido en 7 días hábiles.</p>').insertBefore('.qty-label-l'); $('#left-entrega-estimada input').val('6');} 
    if (l_times == 3){ $('.lc-sistock-container').show(); $('.shipping_date_l').remove(); $('<p class="shipping_date_l" style="margin: 0 0 20px 0; font-weight: bold;"><span style="color:#fb4e0c;">TIEMPO DE ENTREGA:</span> Lentes importados. Recibirás tu pedido en 55 días hábiles.</p>').insertBefore('.qty-label-l'); $('#left-entrega-estimada input').val('60');} 
    if (r_times == 1){ $('.lc-sistock-container').show(); $('.shipping_date_r').remove(); $('<p class="shipping_date_r" style="margin: 0 0 20px 0; font-weight: bold;"><span style="color:#fb4e0c;">TIEMPO DE ENTREGA:</span> Recibirás tu pedido en 7 días hábiles.</p>').insertBefore('.qty-label-r'); $('#right-entrega-estimada input').val('6');} 
    if (r_times == 2){ $('.lc-sistock-container').show(); $('.shipping_date_r').remove(); $('<p class="shipping_date_r" style="margin: 0 0 20px 0; font-weight: bold;"><span style="color:#fb4e0c;">TIEMPO DE ENTREGA:</span> Recibirás tu pedido en 7 días hábiles.</p>').insertBefore('.qty-label-r'); $('#right-entrega-estimada input').val('6');} 
    if (r_times == 3){ $('.lc-sistock-container').show(); $('.shipping_date_r').remove(); $('<p class="shipping_date_r" style="margin: 0 0 20px 0; font-weight: bold;"><span style="color:#fb4e0c;">TIEMPO DE ENTREGA:</span> Lentes importados. Recibirás tu pedido en 55 días hábiles.</p>').insertBefore('.qty-label-r'); $('#right-entrega-estimada input').val('60');} 
    if (l_times == 3 || r_times == 3){$('.shipping_date_cls').remove(); $('<p class="shipping_date_cls" style="margin: 10px 0 20px 0; font-weight: bold;"><span style="color:#fb4e0c; line-height: 2;">¿Mucho tiempo esperando la llegada de tus Lentes de Contacto?</span> <br> Conoce nuestro plan de <a style="color: #0055b8; font-weight: bold;" href="https://ecomcol.essilorluxottica.com/" target="_blank">Suscripción All-Inclusive</a> para recibir tus lentes de contacto en tu casa, con la frecuencia que necesitas, sin esperas.</p>').insertAfter('.contact-lens-configurator__prescription');}
    if (l_times == 4){$('.shipping_date_change').remove(); $('.shipping_date_l, .shipping_date_cls').remove(); $('.lc-sistock-container').hide(); $('<p class="shipping_date_l" style="margin: 0 0 20px 0; font-weight: bold;">No disponible.</p>').insertBefore('.qty-label-l');} 
    if (r_times == 4){$('.shipping_date_change').remove(); $('.shipping_date_r, .shipping_date_cls').remove(); $('.lc-sistock-container').hide(); $('<p class="shipping_date_l" style="margin: 0 0 20px 0; font-weight: bold;">No disponible.</p>').insertBefore('.qty-label-r');} 
    if (l_times == 5){$('.shipping_date_change').remove(); $('.shipping_date_l, .shipping_date_cls').remove(); $('.lc-sistock-container').hide(); $('<p class="shipping_date_l" style="margin: 0 0 20px 0; font-weight: bold;"><span style="color:#000;">No disponible.</p>').insertBefore('.qty-label-l'); $('<p class="shipping_date_change" style="margin: 30px 0 20px 0; padding: 15px 10px 20px 10px; background-color: #fff288;"> <b>ATENCIÓN</b> <br> Esta referencia está en proceso de descontinuación y tu fórmula ya no está disponible. Realiza con nosotros una prueba de Lentes de Contacto sin Costo* para cambiarte a otra marca o referencia. <br><br> <a targer="_blank" style="color:#0055b8;" href="https://www.lafam.com.co/pages/agenda-tu-cita">Agenda aquí</a> - <a style="color: #0055b8;" targer="_blank" href="https://api.whatsapp.com/send?phone=573102959931">Contacta a un asesor</a> </p>').insertAfter('.contact-lens-configurator__prescription');} 
    if (r_times == 5){$('.shipping_date_change').remove(); $('.shipping_date_r, .shipping_date_cls').remove(); $('.lc-sistock-container').hide(); $('<p class="shipping_date_l" style="margin: 0 0 20px 0; font-weight: bold;"><span style="color:#000;">No disponible.</p>').insertBefore('.qty-label-r'); $('<p class="shipping_date_change" style="margin: 30px 0 20px 0; padding: 15px 10px 20px 10px; background-color: #fff288;"> <b>ATENCIÓN</b> <br> Esta referencia está en proceso de descontinuación y tu fórmula ya no está disponible. Realiza con nosotros una prueba de Lentes de Contacto sin Costo* para cambiarte a otra marca o referencia. <br><br> <a targer="_blank" style="color:#0055b8;" href="https://www.lafam.com.co/pages/agenda-tu-cita">Agenda aquí</a> - <a style="color: #0055b8;" targer="_blank" href="https://api.whatsapp.com/send?phone=573102959931">Contacta a un asesor</a> </p>').insertAfter('.contact-lens-configurator__prescription');} 
    if (l_times == 4 || r_times == 4 || l_times == 5 || r_times == 5){$('.lc-sistock-container').hide();}
  },300);
}


function fetch_sku_l(){
  switch (sku_values_l) { 
case '- 5.75_- 1.25_170°' : $('#left-sku input').val('|239826'); l_times = 3; check_times(); break;
case '- 5.50_- 1.25_160°' : $('#left-sku input').val('|239855'); l_times = 3; check_times(); break;
case '- 5.00_- 0.75_160°' : $('#left-sku input').val('|239905'); l_times = 3; check_times(); break;
case '- 5.00_- 1.25_10°' : $('#left-sku input').val('|239908'); l_times = 3; check_times(); break;
case '- 5.00_- 1.25_170°' : $('#left-sku input').val('|239916'); l_times = 3; check_times(); break;
case '- 4.75_- 0.75_180°' : $('#left-sku input').val('|239937'); l_times = 3; check_times(); break;
case '- 4.50_- 0.75_180°' : $('#left-sku input').val('|239967'); l_times = 3; check_times(); break;
case '- 4.50_- 1.25_170°' : $('#left-sku input').val('|239976'); l_times = 3; check_times(); break;
case '- 4.25_- 0.75_180°' : $('#left-sku input').val('|239997'); l_times = 3; check_times(); break;
case '- 4.25_- 1.25_180°' : $('#left-sku input').val('|240007'); l_times = 3; check_times(); break;
case '- 4.00_- 1.25_180°' : $('#left-sku input').val('|240037'); l_times = 3; check_times(); break;
case '- 3.75_- 0.75_180°' : $('#left-sku input').val('|240057'); l_times = 3; check_times(); break;
case '- 3.50_- 1.25_10°' : $('#left-sku input').val('|240088'); l_times = 3; check_times(); break;
case '- 3.25_- 0.75_90°' : $('#left-sku input').val('|240112'); l_times = 3; check_times(); break;
case '- 3.00_- 1.25_20°' : $('#left-sku input').val('|240149'); l_times = 3; check_times(); break;
case '- 3.00_- 1.75_10°' : $('#left-sku input').val('|240158'); l_times = 3; check_times(); break;
case '- 2.75_- 0.75_180°' : $('#left-sku input').val('|240177'); l_times = 3; check_times(); break;
case '- 2.75_- 1.75_180°' : $('#left-sku input').val('|240197'); l_times = 3; check_times(); break;
case '- 2.50_- 0.75_90°' : $('#left-sku input').val('|240202'); l_times = 3; check_times(); break;
case '- 2.50_- 0.75_180°' : $('#left-sku input').val('|240207'); l_times = 3; check_times(); break;
case '- 2.25_- 1.25_160°' : $('#left-sku input').val('|240245'); l_times = 3; check_times(); break;
case '- 2.25_- 1.25_170°' : $('#left-sku input').val('|240246'); l_times = 3; check_times(); break;
case '- 2.25_- 0.75_10°' : $('#left-sku input').val('|240228'); l_times = 3; check_times(); break;
case '- 2.00_- 0.75_180°' : $('#left-sku input').val('|240267'); l_times = 3; check_times(); break;
case '- 2.00_- 1.25_10°' : $('#left-sku input').val('|240268'); l_times = 3; check_times(); break;
case '- 2.00_- 1.25_160°' : $('#left-sku input').val('|240275'); l_times = 3; check_times(); break;
case '- 2.00_- 1.25_180°' : $('#left-sku input').val('|240277'); l_times = 3; check_times(); break;
case '- 2.00_- 1.75_10°' : $('#left-sku input').val('|240278'); l_times = 3; check_times(); break;
case '- 2.00_- 1.75_170°' : $('#left-sku input').val('|240286'); l_times = 3; check_times(); break;
case '- 1.75_- 0.75_20°' : $('#left-sku input').val('|240289'); l_times = 3; check_times(); break;
case '- 1.75_- 0.75_180°' : $('#left-sku input').val('|240297'); l_times = 3; check_times(); break;
case '- 1.75_- 1.75_180°' : $('#left-sku input').val('|240317'); l_times = 3; check_times(); break;
case '- 1.50_- 0.75_90°' : $('#left-sku input').val('|240322'); l_times = 3; check_times(); break;
case '- 1.50_- 1.25_180°' : $('#left-sku input').val('|240337'); l_times = 3; check_times(); break;
case '- 1.50_- 0.75_170°' : $('#left-sku input').val('|240326'); l_times = 3; check_times(); break;
case '- 1.25_- 0.75_70°' : $('#left-sku input').val('|240350'); l_times = 3; check_times(); break;
case '- 1.25_- 0.75_160°' : $('#left-sku input').val('|240355'); l_times = 3; check_times(); break;
case '- 1.25_- 1.25_180°' : $('#left-sku input').val('|240367'); l_times = 3; check_times(); break;
case '- 1.00_- 0.75_90°' : $('#left-sku input').val('|240382'); l_times = 3; check_times(); break;
case '- 0.75_- 0.75_70°' : $('#left-sku input').val('|240410'); l_times = 3; check_times(); break;
case '- 0.75_- 1.25_10°' : $('#left-sku input').val('|240418'); l_times = 3; check_times(); break;
case '- 0.75_- 1.25_180°' : $('#left-sku input').val('|240427'); l_times = 3; check_times(); break;
case '- 0.50_- 0.75_20°' : $('#left-sku input').val('|240439'); l_times = 3; check_times(); break;
case '- 0.50_- 0.75_90°' : $('#left-sku input').val('|240442'); l_times = 3; check_times(); break;
case '- 0.25_- 1.25_180°' : $('#left-sku input').val('|240487'); l_times = 3; check_times(); break;
case '+ 0.00_- 1.25_70°' : $('#left-sku input').val('|240510'); l_times = 3; check_times(); break;
case '+ 0.00_- 1.25_160°' : $('#left-sku input').val('|240515'); l_times = 3; check_times(); break;
case '+ 0.00_- 1.25_180°' : $('#left-sku input').val('|240517'); l_times = 3; check_times(); break;
case '+ 0.00_- 0.75_80°' : $('#left-sku input').val('|240501'); l_times = 3; check_times(); break;
case '+ 0.25_- 1.25_80°' : $('#left-sku input').val('|240541'); l_times = 3; check_times(); break;
case '+ 0.25_- 1.25_180°' : $('#left-sku input').val('|240547'); l_times = 3; check_times(); break;
case '+ 0.50_- 0.75_100°' : $('#left-sku input').val('|240563'); l_times = 3; check_times(); break;

case 'null' : $('.shipping_date_change, .shipping_date_cls').remove(); l_times = 4 ; check_times(); break;
default: l_times = 4; check_times(); break;
  
  }
}//fetch_sku()

function fetch_sku_r(){
  switch (sku_values_r) { 
case '- 5.75_- 1.25_170°' : $('#right-sku input').val('|239826'); r_times = 3; check_times(); break;
case '- 5.50_- 1.25_160°' : $('#right-sku input').val('|239855'); r_times = 3; check_times(); break;
case '- 5.00_- 0.75_160°' : $('#right-sku input').val('|239905'); r_times = 3; check_times(); break;
case '- 5.00_- 1.25_10°' : $('#right-sku input').val('|239908'); r_times = 3; check_times(); break;
case '- 5.00_- 1.25_170°' : $('#right-sku input').val('|239916'); r_times = 3; check_times(); break;
case '- 4.75_- 0.75_180°' : $('#right-sku input').val('|239937'); r_times = 3; check_times(); break;
case '- 4.50_- 0.75_180°' : $('#right-sku input').val('|239967'); r_times = 3; check_times(); break;
case '- 4.50_- 1.25_170°' : $('#right-sku input').val('|239976'); r_times = 3; check_times(); break;
case '- 4.25_- 0.75_180°' : $('#right-sku input').val('|239997'); r_times = 3; check_times(); break;
case '- 4.25_- 1.25_180°' : $('#right-sku input').val('|240007'); r_times = 3; check_times(); break;
case '- 4.00_- 1.25_180°' : $('#right-sku input').val('|240037'); r_times = 3; check_times(); break;
case '- 3.75_- 0.75_180°' : $('#right-sku input').val('|240057'); r_times = 3; check_times(); break;
case '- 3.50_- 1.25_10°' : $('#right-sku input').val('|240088'); r_times = 3; check_times(); break;
case '- 3.25_- 0.75_90°' : $('#right-sku input').val('|240112'); r_times = 3; check_times(); break;
case '- 3.00_- 1.25_20°' : $('#right-sku input').val('|240149'); r_times = 3; check_times(); break;
case '- 3.00_- 1.75_10°' : $('#right-sku input').val('|240158'); r_times = 3; check_times(); break;
case '- 2.75_- 0.75_180°' : $('#right-sku input').val('|240177'); r_times = 3; check_times(); break;
case '- 2.75_- 1.75_180°' : $('#right-sku input').val('|240197'); r_times = 3; check_times(); break;
case '- 2.50_- 0.75_90°' : $('#right-sku input').val('|240202'); r_times = 3; check_times(); break;
case '- 2.50_- 0.75_180°' : $('#right-sku input').val('|240207'); r_times = 3; check_times(); break;
case '- 2.25_- 1.25_160°' : $('#right-sku input').val('|240245'); r_times = 3; check_times(); break;
case '- 2.25_- 1.25_170°' : $('#right-sku input').val('|240246'); r_times = 3; check_times(); break;
case '- 2.25_- 0.75_10°' : $('#right-sku input').val('|240228'); r_times = 3; check_times(); break;
case '- 2.00_- 0.75_180°' : $('#right-sku input').val('|240267'); r_times = 3; check_times(); break;
case '- 2.00_- 1.25_10°' : $('#right-sku input').val('|240268'); r_times = 3; check_times(); break;
case '- 2.00_- 1.25_160°' : $('#right-sku input').val('|240275'); r_times = 3; check_times(); break;
case '- 2.00_- 1.25_180°' : $('#right-sku input').val('|240277'); r_times = 3; check_times(); break;
case '- 2.00_- 1.75_10°' : $('#right-sku input').val('|240278'); r_times = 3; check_times(); break;
case '- 2.00_- 1.75_170°' : $('#right-sku input').val('|240286'); r_times = 3; check_times(); break;
case '- 1.75_- 0.75_20°' : $('#right-sku input').val('|240289'); r_times = 3; check_times(); break;
case '- 1.75_- 0.75_180°' : $('#right-sku input').val('|240297'); r_times = 3; check_times(); break;
case '- 1.75_- 1.75_180°' : $('#right-sku input').val('|240317'); r_times = 3; check_times(); break;
case '- 1.50_- 0.75_90°' : $('#right-sku input').val('|240322'); r_times = 3; check_times(); break;
case '- 1.50_- 1.25_180°' : $('#right-sku input').val('|240337'); r_times = 3; check_times(); break;
case '- 1.50_- 0.75_170°' : $('#right-sku input').val('|240326'); r_times = 3; check_times(); break;
case '- 1.25_- 0.75_70°' : $('#right-sku input').val('|240350'); r_times = 3; check_times(); break;
case '- 1.25_- 0.75_160°' : $('#right-sku input').val('|240355'); r_times = 3; check_times(); break;
case '- 1.25_- 1.25_180°' : $('#right-sku input').val('|240367'); r_times = 3; check_times(); break;
case '- 1.00_- 0.75_90°' : $('#right-sku input').val('|240382'); r_times = 3; check_times(); break;
case '- 0.75_- 0.75_70°' : $('#right-sku input').val('|240410'); r_times = 3; check_times(); break;
case '- 0.75_- 1.25_10°' : $('#right-sku input').val('|240418'); r_times = 3; check_times(); break;
case '- 0.75_- 1.25_180°' : $('#right-sku input').val('|240427'); r_times = 3; check_times(); break;
case '- 0.50_- 0.75_20°' : $('#right-sku input').val('|240439'); r_times = 3; check_times(); break;
case '- 0.50_- 0.75_90°' : $('#right-sku input').val('|240442'); r_times = 3; check_times(); break;
case '- 0.25_- 1.25_180°' : $('#right-sku input').val('|240487'); r_times = 3; check_times(); break;
case '+ 0.00_- 1.25_70°' : $('#right-sku input').val('|240510'); r_times = 3; check_times(); break;
case '+ 0.00_- 1.25_160°' : $('#right-sku input').val('|240515'); r_times = 3; check_times(); break;
case '+ 0.00_- 1.25_180°' : $('#right-sku input').val('|240517'); r_times = 3; check_times(); break;
case '+ 0.00_- 0.75_80°' : $('#right-sku input').val('|240501'); r_times = 3; check_times(); break;
case '+ 0.25_- 1.25_80°' : $('#right-sku input').val('|240541'); r_times = 3; check_times(); break;
case '+ 0.25_- 1.25_180°' : $('#right-sku input').val('|240547'); r_times = 3; check_times(); break;
case '+ 0.50_- 0.75_100°' : $('#right-sku input').val('|240563'); r_times = 3; check_times(); break;

case 'null' : $('.shipping_date_change, .shipping_date_cls').remove(); r_times = 4 ; check_times(); break;
default: r_times = 4; check_times(); break;

  }
}//fetch_sku()

